<template>
  <div id="app" class="app-view mx-auto">
    <b-navbar
      class="border-bottom bg-white"
      :class="{'d-none':isLoggingIn}"
      toggleable="sm"
      fixed
      type="light"
    >
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand to="order" class="px-4">
        <b-img width="200" :src="require('./assets/seaway_logo.png')" fluid></b-img>
      </b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item to="/order">Order</b-nav-item>
          <b-nav-item @click="logout">Logout</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AuthState } from "@/store/app";
import { mapState } from "vuex";
export default {
  name: "app",
  components: {},
  methods: {
    logout() {
      this.$store.dispatch("app/logout").then(() => {
        this.$router.push("/");
        console.log("logout");
      });
    }
  },
  computed: {
    isLoggingIn() {
      return this.$store.state.app.authStatus != AuthState.AUTHENTICATED;
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
  width: 100%;
  background-color: #292b2c !important;
}
</style>
